import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=03542bfe&scoped=true&"
import script from "./Instructions.vue?vue&type=script&lang=js&"
export * from "./Instructions.vue?vue&type=script&lang=js&"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=03542bfe&lang=scss&scoped=true&"
import style1 from "./Instructions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03542bfe",
  null
  
)

export default component.exports